export default __webpack_public_path__ + "static/media/2526 cutlery side.742dc44f.png";